import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { FiLoader, FiDownload } from "react-icons/fi";
import { AiFillShop, AiFillCreditCard, AiFillBank } from 'react-icons/ai';
import { FaFileDownload, FaCheckCircle } from "react-icons/fa";
import { FaLinkSlash } from "react-icons/fa6";
import { MdOutlineReceipt } from "react-icons/md";
import favicon from './favicon.ico';
import full from './full_logo.png';

export const config = {
  Accept: 'application/json',
  headers: {
    // Authorization: `Bearer ${token}`,
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
};

const baseURL = process.env.REACT_APP_BASE_URL;

function LeftPaymentSide({
  setPaymentType, paymentType, amount, handlePay,
  loading, product, companyName, companyLogo, Surcharge,
  isPaid,
  products,
  userName,
  handleInvoice,
  discountEnabled,
  taxEnabled,
  productEnabled,
  address, CompanyId,
  isExpired,
  payType,
  paymentIntent,
  paymentMethod,
}) {
  const [TotalAmount, setTotalAmount] = useState(0);
  const [AddProductPrice, setAddProductPrice] = useState(0);
  const [AddProductDiscount, setAddProductDiscount] = useState(0);
  const [AddProductTax, setAddProductTax] = useState(0);

  const allowedPayTypes = ['cc', 'ach', 'cc-ach'];
  const normalizedPayType = allowedPayTypes.includes(String(payType || '').toLowerCase())
    ? String(payType).toLowerCase()
    : 'cc-ach';
  const showCard = normalizedPayType === 'cc' || normalizedPayType === 'cc-ach';
  const showAch = normalizedPayType === 'ach' || normalizedPayType === 'cc-ach';
  
  useEffect(() => {
    let totalPrice = 0;
    let totalDiscount = 0;
    let Totaltax = 0;
    for (const product of products || []) {
      const productTotalPrice = product.price * product.quantity;
      totalPrice += productTotalPrice;
      const discountValue = Number(product.discount) || 0;
      const isUsdDiscount = String(product.discountType || '').toUpperCase() === 'USD';
      const productTotalDiscount = isUsdDiscount
        ? discountValue
        : (productTotalPrice * discountValue) / 100;
      totalDiscount += productTotalDiscount;
      const productTotalTAX = ((productTotalPrice - productTotalDiscount) * product.tax) / 100;
      Totaltax += productTotalTAX;
    }
    setAddProductPrice(totalPrice.toFixed(2));
    setAddProductDiscount(totalDiscount.toFixed(2));
    setAddProductTax(Totaltax.toFixed(2));
    setTotalAmount((totalPrice - totalDiscount + Totaltax).toFixed(2));
  }, [paymentType, loading, products, isPaid]);

  const amountAfterDiscount = productEnabled && products?.length
    ? Number(TotalAmount) || 0
    : (Number(amount) || 0) / 100;

  const paidCents = paymentIntent?.amount_received ?? paymentIntent?.amount;
  const paidWithCard = isPaid && (
    paymentMethod?.type === 'card'
    || paymentIntent?.payment_method_types?.includes('card')
  );
  const forceCard = CompanyId === '066800de-5664-4511-ac67-d1a700495a38'
    || CompanyId === 'c07d4186-75ce-41de-a770-98f74469633f'
    || normalizedPayType === 'cc';

  const applyConvenienceFee = isPaid
    ? Boolean(Surcharge && (paidWithCard || (paidCents != null && paidCents > Math.round(amountAfterDiscount * 100))))
    : ((paymentType === 'card' || forceCard) && Surcharge === true);

  const convenienceFee = isPaid && paidCents != null
    ? Math.max(0, (Number(paidCents) / 100) - amountAfterDiscount)
    : (applyConvenienceFee ? amountAfterDiscount * 0.03 : 0);

  const payableTotal = isPaid && paidCents != null
    ? (Number(paidCents) / 100).toFixed(2)
    : (amountAfterDiscount + (applyConvenienceFee ? amountAfterDiscount * 0.03 : 0)).toFixed(2);

  const displaySubtotal = amountAfterDiscount.toFixed(2);

  if (isExpired === true) {
    return (
      <div className="w-full h-full items-center justify-center flex flex-col">
        <FaLinkSlash className="text-[80px] mb-[20px]" />
        <span className="text-[30px] medium">
          Link Expired
        </span>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-screen  flex flex-col items-center justify-center p-4" id="payment-receipt">
      {/* Modern Header */}
      <div className="w-full max-w-md mb-6">
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/20">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {companyLogo && (
                <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 p-0.5">
                  <div className="w-full h-full rounded-xl bg-white p-2">
                    <img className="w-full h-full object-contain" src={companyLogo} alt="Company Logo" />
                  </div>
                </div>
              )}
              <div className="flex-1">
                <h1 className="text-xl font-bold text-gray-800 leading-tight">{companyName}</h1>
                <p className="text-sm text-gray-500 leading-tight">
                  {address?.street_address} {address?.apartment_or_suite}
                </p>
                <p className="text-sm text-gray-500">
                  {address?.city}, {address?.state_or_province} {address?.zip}
                </p>
              </div>
            </div>
            
            {/* Download Invoice Button - Only show when paid */}
            {isPaid && (
              <div className="ml-4">
                <button 
                  onClick={handleInvoice} 
                  className="group flex items-center space-x-2 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-4 py-2 rounded-xl shadow-lg transition-all duration-200 transform hover:scale-105"
                >
                  <FiDownload className="w-4 h-4 group-hover:animate-bounce" />
                  <span className="text-sm font-medium">Invoice</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modern Payment Card */}
      <div className="w-full max-w-md">
        <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/20 overflow-hidden">
          {/* Card Header */}
          <div className="bg-slate-50 p-6">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-lg font-semibold text-slate-800">Payment Details</h2>
              </div>
              {isPaid && (
                <div className="flex items-center space-x-2 bg-emerald-50 rounded-full px-3 py-1">
                  <FaCheckCircle className="w-4 h-4 text-emerald-500" />
                  <span className="text-sm font-medium text-emerald-500">Paid</span>
                </div>
              )}
            </div>
          </div>

          {/* Card Content */}
          <div className="p-6">
            {/* Bill To */}
            <div className="flex items-center justify-between py-3 border-b border-gray-100">
              <span className="text-gray-600 font-medium">Bill to:</span>
              <span className="text-gray-800 font-semibold">{userName}</span>
            </div>

            {/* Product Details */}
            {productEnabled === true && products?.length > 1 && (
              <div className="border-b border-gray-100 pb-4">
                <h3 className="text-gray-600 font-medium mb-3">Products:</h3>
                <div className="space-y-2 max-h-32 overflow-y-auto">
                  {products?.map((field, index) => (
                    <div key={index} className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">
                        {field.quantity}× {field.product}
                      </span>
                      <span className="font-medium text-gray-800">
                        ${(field.price * field.quantity).toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Single Product or Service */}
            {(productEnabled === true && products?.length === 1) || !productEnabled && (
              <div className="text-center py-4 border-b border-gray-100">
                <div className="inline-flex items-center space-x-2 bg-gray-50 rounded-full px-4 py-2">
                  <MdOutlineReceipt className="w-4 h-4 text-gray-500" />
                  <span className="text-gray-700 font-medium">
                    {productEnabled ? products[0]?.product : product}
                  </span>
                </div>
              </div>
            )}

            {/* Amount Breakdown */}
            <div className="space-y-3">
              {/* Subtotal */}
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Subtotal</span>
                <span className="font-medium text-gray-800">
                  ${productEnabled && products?.length ? AddProductPrice : displaySubtotal}
                </span>
              </div>

              {/* Discount */}
              {discountEnabled && productEnabled && products?.length > 0 && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Discount</span>
                  <span className="font-medium text-red-500">-${AddProductDiscount}</span>
                </div>
              )}

              {/* Tax */}
              {taxEnabled && productEnabled && products?.length > 0 && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Tax</span>
                  <span className="font-medium text-gray-800">${AddProductTax}</span>
                </div>
              )}

              {/* Convenience Fee */}
              {applyConvenienceFee && convenienceFee > 0 && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600 text-sm">Convenience fee (3%)</span>
                  <span className="font-medium text-gray-800">
                    ${convenienceFee.toFixed(2)}
                  </span>
                </div>
              )}

              {/* Total Amount */}
              {isPaid === false && (
                <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                  <span className="text-lg font-semibold text-gray-800">Total Amount Payable</span>
                  <span className="text-xl font-bold text-gray-800">
                    ${payableTotal}
                  </span>
                </div>
              )}

              {/* Total Paid */}
              {isPaid === true && (
                <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                  <span className="text-lg font-semibold text-gray-800">Total Paid</span>
                  <span className="text-xl font-bold text-gray-800">
                    ${payableTotal}
                  </span>
                </div>
              )}

              {/* Balance Due */}
              {isPaid && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Balance Due</span>
                  <span className="font-bold text-green-600">$0.00</span>
                </div>
              )}
            </div>

            {/* Payment Method Selection — only when both Card and ACH are available */}
            {isPaid === false && showAch && showCard && (
              <div className="pt-6 space-y-4">
                <label className="text-gray-700 font-medium text-sm">Payment method</label>
                <div className="grid grid-cols-2 gap-3">
                  <button
                    onClick={() => setPaymentType('ACH')}
                    type="button"
                    className={`flex items-center space-x-3 p-4 rounded-xl border-2 transition-all duration-200 ${
                      paymentType === 'ACH' 
                        ? 'border-blue-500 bg-blue-50' 
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className={`w-4 h-4 rounded-full border-2 ${
                      paymentType === 'ACH' ? 'border-blue-500 bg-blue-500' : 'border-gray-300'
                    }`}>
                      {paymentType === 'ACH' && <div className="w-full h-full rounded-full bg-white scale-50"></div>}
                    </div>
                    <div className="flex flex-row items-start gap-2">
                      <AiFillBank className="w-5 h-5 text-gray-600 self-center" />
                      <span className="text-xs font-medium text-gray-700 self-center">ACH</span>
                    </div>
                  </button>
                  
                  <button
                    onClick={() => setPaymentType('card')}
                    type="button"
                    className={`flex items-center space-x-3 p-4 rounded-xl border-2 transition-all duration-200 ${
                      paymentType === 'card' 
                        ? 'border-blue-500 bg-blue-50' 
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className={`w-4 h-4 rounded-full border-2 ${
                      paymentType === 'card' ? 'border-blue-500 bg-blue-500' : 'border-gray-300'
                    }`}>
                      {paymentType === 'card' && <div className="w-full h-full rounded-full bg-white scale-50"></div>}
                    </div>
                    <div className="flex flex-row items-start gap-2">
                      <AiFillCreditCard className="w-5 h-5 text-blue-600 self-center" />
                      <span className="text-xs font-medium text-gray-700 self-center">Card</span>
                    </div>
                  </button>
                </div>
              </div>
            )}

            {/* Action Button */}
            <div className="pt-6">
              {isPaid ? (
                <div className="w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white font-semibold py-4 text-center rounded-2xl">
                  <div className="flex items-center justify-center space-x-2">
                    <FaCheckCircle className="w-5 h-5" />
                    <span>Payment Completed</span>
                  </div>
                </div>
              ) : (
                <button 
                  disabled={loading} 
                  onClick={handlePay} 
                  className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 disabled:from-gray-400 disabled:to-gray-500 text-white font-semibold py-4 text-center rounded-2xl transition-all duration-200 transform hover:scale-105 shadow-lg disabled:transform-none disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <div className="flex items-center justify-center space-x-2">
                      <FiLoader className="w-5 h-5 animate-spin" />
                      <span>Processing...</span>
                    </div>
                  ) : (
                    'Pay Now'
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 flex items-center space-x-2 text-gray-500">
        <span className="text-sm">Powered by</span>
        <img className="h-4" src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} alt="SalesCaptain" />
        <span className="text-sm capitalize">{localStorage.getItem('h_name') ?? 'SalesCaptain'}</span>
      </div>
    </div>
  );
}

const StripePaymentsLink = () => {
  const { id } = useParams();
  const [amount, setAmount] = useState();
  const [product, setProduct] = useState('');
  const [paymentType, setPaymentType] = useState('ACH');
  const [accountId, setAccountId] = useState('');
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');
  const [Surcharge, setSurcharge] = useState(false);
  const [isPaid, setIsPaid] = useState(false);
  const [isExpired, setisExpired] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [products, setProducts] = useState([]);
  const [userName, setUserName] = useState('');
  const [productEnabled, setProductEnabled] = useState(false);
  const [taxEnabled, setTaxEnabled] = useState(false);
  const [discountEnabled, setDiscountEnabled] = useState(false);
  const [address, setAddress] = useState([]);
  const [CompanyId, setCompanyId] = useState('');
  const [stripeData, setStripeData] = useState(null);
  const [payType, setPayType] = useState('cc-ach');

  useEffect(() => {
    handleGetPaymentCheckout();
  }, []);

  const handleGetPaymentCheckout = async () => {
    setLoading1(true);
    const response = await axios.get(`${baseURL}/payment/get-price-checkoutt/${id}`, config);
    
    if (response.data.status === 'success') {
      const data = response.data.data;
      setStripeData(data);
      setAmount(data.price);
      setAccountId(data.stripe_account_id);
      setCompanyId(data.company_id);
      setProduct(data.product_name);
      setCompanyLogo(data.company_logo);
      setCompanyName(data.company_name);
      setSurcharge(data.surcharge);
      setIsPaid(data.is_paid);
      setProducts(data.products || []);
      setUserName(data.name);
      setDiscountEnabled(data.settings?.is_discount_enabled);
      setTaxEnabled(data.settings?.is_tax_enabled);
      setProductEnabled(data.settings?.bill_to_name);
      setAddress(data.company_address);
      setisExpired(data.is_expired);
      const rawPayType = data.pay_type ?? data.settings?.pay_type;
      const allowedPayTypes = ['cc', 'ach', 'cc-ach'];
      const nextPayType = allowedPayTypes.includes(String(rawPayType || '').toLowerCase())
        ? String(rawPayType).toLowerCase()
        : 'cc-ach';
      setPayType(nextPayType);
      if (nextPayType === 'cc') {
        setPaymentType('card');
      } else {
        setPaymentType('ACH');
      }
    }
    setLoading1(false);
  };

  const handlePay = async () => {
    setLoading(true);
    let amountAfterDiscount = (amount / 100);
    if (productEnabled && products?.length) {
      let totalPrice = 0;
      let totalDiscount = 0;
      let totalTax = 0;
      for (const product of products) {
        const productTotalPrice = product.price * product.quantity;
        totalPrice += productTotalPrice;
        const discountValue = Number(product.discount) || 0;
        const isUsdDiscount = String(product.discountType || '').toUpperCase() === 'USD';
        const productTotalDiscount = isUsdDiscount
          ? discountValue
          : (productTotalPrice * discountValue) / 100;
        totalDiscount += productTotalDiscount;
        totalTax += ((productTotalPrice - productTotalDiscount) * (product.tax || 0)) / 100;
      }
      amountAfterDiscount = totalPrice - totalDiscount + totalTax;
    }
    const forceCard = CompanyId === '066800de-5664-4511-ac67-d1a700495a38' || CompanyId === 'c07d4186-75ce-41de-a770-98f74469633f' || String(payType).toLowerCase() === 'cc';
    const applySurcharge = ((paymentType === 'card' || forceCard) && Surcharge === true);
    const surchargeAmount = applySurcharge ? amountAfterDiscount * 0.03 : 0;

    const response = await axios.post(`${baseURL}/payment/create-payment-checkout/${id}`, {
      payment_method: forceCard ? 'card' : paymentType,
      amount: amountAfterDiscount.toFixed(2),
      surcharge: Number(surchargeAmount.toFixed(2)),
    });
    if (response.data.status === 'success') {
      window.open(response.data.data, '_self');
      setLoading(false);
    }
  };

  const handleInvoice = async () => {
    const invoiceData = stripeData;
    if (!invoiceData) return;

    const invoiceNumber =
      (invoiceData.self_invoice_id && String(invoiceData.self_invoice_id).trim())
        ? String(invoiceData.self_invoice_id).trim()
        : invoiceData?.checkout_price_id || invoiceData?.session_id;

    const paymentIntent = invoiceData.payment_intent;
    const paymentMethod = invoiceData.payment_method;
    const paidCents = paymentIntent?.amount_received ?? paymentIntent?.amount ?? invoiceData.price ?? amount ?? 0;
    const totalPaid = (Number(paidCents) / 100).toFixed(2);

    const paymentDateSource = paymentIntent?.created
      ? new Date(paymentIntent.created * 1000)
      : invoiceData.created_at
        ? new Date(invoiceData.created_at)
        : new Date();
    const paymentDate = paymentDateSource.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

    const street = [address?.street_address, address?.apartment_or_suite]
      .filter((p) => p && String(p).trim())
      .join(' ');
    const cityState = [address?.city, address?.state_or_province]
      .filter((p) => p && String(p).trim())
      .join(', ');
    const cityLine = [cityState, address?.zip].filter((p) => p && String(p).trim()).join(' ');

    const card = paymentMethod?.card;
    const pmType = paymentMethod?.type || paymentIntent?.payment_method_types?.[0] || '';
    let paymentMethodLabel = 'N/A';
    if (card) {
      const brand = (card.display_brand || card.brand || 'Card').replace(/^\w/, (c) => c.toUpperCase());
      paymentMethodLabel = `${brand} •••• ${card.last4 || '----'}`;
    } else if (pmType === 'us_bank_account' || pmType === 'ach_debit') {
      paymentMethodLabel = 'ACH / Bank Transfer';
    } else if (pmType) {
      paymentMethodLabel = String(pmType).replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
    }

    const productList = Array.isArray(invoiceData.products) ? invoiceData.products : [];
    let itemsHtml = '';
    let subtotal = 0;
    let totalDiscount = 0;
    let totalTax = 0;

    if (productList.length > 0) {
      itemsHtml = productList.map((item) => {
        const lineTotal = Number(item.price || 0) * Number(item.quantity || 1);
        subtotal += lineTotal;
        const discountValue = Number(item.discount) || 0;
        const isUsdDiscount = String(item.discountType || '').toUpperCase() === 'USD';
        const lineDiscount = isUsdDiscount ? discountValue : (lineTotal * discountValue) / 100;
        totalDiscount += lineDiscount;
        const lineTax = ((lineTotal - lineDiscount) * (Number(item.tax) || 0)) / 100;
        totalTax += lineTax;
        return `
          <tr>
            <td class="px-6 py-4 text-sm text-gray-900">
              <div class="font-medium">${item.product || item.name || product || 'Item'}</div>
              <div class="text-gray-500 text-xs">${item.quantity || 1} × $${Number(item.price || 0).toFixed(2)}</div>
            </td>
            <td class="px-6 py-4 text-sm text-gray-900 text-right">$${lineTotal.toFixed(2)}</td>
          </tr>
        `;
      }).join('');
    } else {
      subtotal = Number(invoiceData.price || amount || 0) / 100;
      itemsHtml = `
        <tr>
          <td class="px-6 py-4 text-sm text-gray-900">
            <div class="font-medium">${invoiceData.product_name || product || 'Payment'}</div>
          </td>
          <td class="px-6 py-4 text-sm text-gray-900 text-right">$${subtotal.toFixed(2)}</td>
        </tr>
      `;
    }

    const amountBeforeFee = subtotal - totalDiscount + totalTax;
    const surchargeAmount = Math.max(0, Number(totalPaid) - amountBeforeFee);
    const showSurcharge = Boolean(invoiceData.surcharge) && surchargeAmount > 0.009;
    const billingName = paymentMethod?.billing_details?.name || userName || invoiceData.name || '—';
    const billingEmail = paymentMethod?.billing_details?.email || invoiceData.email || '';
    const billingPhone = invoiceData.phone || '';

    const invoiceHTML = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Invoice - ${invoiceNumber}</title>
        <script src="https://cdn.tailwindcss.com"></script>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
          body { font-family: 'Inter', sans-serif; }
          .invoice-header { background: linear-gradient(135deg, #3b82f6 0%, #7c3aed 100%); }
          .status-paid { background: linear-gradient(135deg, #059669 0%, #10b981 100%); }
          @media print {
            body { print-color-adjust: exact; -webkit-print-color-adjust: exact; }
            .no-print { display: none !important; }
          }
        </style>
      </head>
      <body class="bg-gray-50 p-6 md:p-8">
        <div class="max-w-3xl mx-auto bg-white shadow-2xl rounded-xl overflow-hidden">
          <div class="invoice-header text-white px-8 py-6">
            <div class="flex justify-between items-start gap-4">
              <div class="flex items-center space-x-4 min-w-0">
                ${companyLogo ? `<img src="${companyLogo}" alt="Company Logo" class="h-14 w-14 rounded-lg bg-white p-1.5 object-contain shrink-0">` : ''}
                <div class="min-w-0">
                  <h1 class="text-xl md:text-2xl font-bold truncate">${companyName || ''}</h1>
                  ${street ? `<p class="text-blue-100 text-sm">${street}</p>` : ''}
                  ${cityLine ? `<p class="text-blue-100 text-sm">${cityLine}</p>` : ''}
                </div>
              </div>
              <div class="text-right shrink-0">
                <h2 class="text-2xl md:text-3xl font-bold mb-2 tracking-wide">INVOICE</h2>
                <div class="status-paid text-white px-4 py-1.5 rounded-lg inline-block text-sm">
                  <span class="font-semibold">PAID</span>
                </div>
              </div>
            </div>
          </div>

          <div class="px-8 py-6">
            <div style="display:flex;gap:24px;margin-bottom:32px;align-items:stretch;">
              <div style="flex:1;min-width:0;">
                <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Bill To</h3>
                <div class="bg-gray-50 p-4 rounded-lg space-y-1" style="height:100%;">
                  <p class="font-semibold text-gray-900">${billingName}</p>
                  ${billingEmail ? `<p class="text-sm text-gray-600">${billingEmail}</p>` : ''}
                  ${billingPhone ? `<p class="text-sm text-gray-600">${billingPhone}</p>` : ''}
                </div>
              </div>
              <div style="flex:1;min-width:0;">
                <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Invoice Details</h3>
                <div class="bg-gray-50 p-4 rounded-lg space-y-2 text-sm" style="height:100%;">
                  <div class="flex justify-between gap-3">
                    <span class="text-gray-500">Invoice #</span>
                    <span class="font-medium text-gray-900 text-right break-all">${invoiceNumber}</span>
                  </div>
                  <div class="flex justify-between gap-3">
                    <span class="text-gray-500">Payment Date</span>
                    <span class="font-medium text-gray-900">${paymentDate}</span>
                  </div>
                  <div class="flex justify-between gap-3">
                    <span class="text-gray-500">Payment Method</span>
                    <span class="font-medium text-gray-900">${paymentMethodLabel}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-8">
              <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">Items</h3>
              <div class="border border-gray-200 rounded-lg overflow-hidden">
                <table class="w-full">
                  <thead class="bg-gray-50">
                    <tr>
                      <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                      <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-100">
                    ${itemsHtml}
                  </tbody>
                </table>
              </div>
            </div>

            <div class="flex justify-end">
              <div class="w-full max-w-sm">
                <div class="bg-gray-50 p-5 rounded-lg space-y-2 text-sm">
                  <div class="flex justify-between">
                    <span class="text-gray-600">Subtotal</span>
                    <span class="font-medium text-gray-900">$${subtotal.toFixed(2)}</span>
                  </div>
                  ${totalDiscount > 0 ? `
                  <div class="flex justify-between">
                    <span class="text-gray-600">Discount</span>
                    <span class="font-medium text-red-500">-$${totalDiscount.toFixed(2)}</span>
                  </div>` : ''}
                  ${totalTax > 0 ? `
                  <div class="flex justify-between">
                    <span class="text-gray-600">Tax</span>
                    <span class="font-medium text-gray-900">$${totalTax.toFixed(2)}</span>
                  </div>` : ''}
                  ${showSurcharge ? `
                  <div class="flex justify-between">
                    <span class="text-gray-600">Convenience Fee (3%)</span>
                    <span class="font-medium text-gray-900">$${surchargeAmount.toFixed(2)}</span>
                  </div>` : ''}
                  <div class="flex justify-between items-center pt-3 border-t border-gray-200">
                    <span class="text-base font-semibold text-gray-800">Total Amount</span>
                    <span class="text-xl font-bold text-gray-900">$${totalPaid}</span>
                  </div>
                  <div class="flex justify-between items-center">
                    <span class="text-base font-semibold text-green-600">Amount Paid</span>
                    <span class="text-xl font-bold text-green-600">$${totalPaid}</span>
                  </div>
                  <div class="flex justify-between items-center pt-2 border-t border-gray-200">
                    <span class="text-base font-semibold text-gray-800">Balance Due</span>
                    <span class="text-xl font-bold text-gray-800">$0.00</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-8 pt-6 border-t border-gray-200 text-center text-gray-500">
              <p class="text-sm">Thank you for your business!</p>
              <div class="flex justify-center items-center mt-4">
                <span class="text-xs">Powered by</span>
                <img src="https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png" class="h-4 ml-2" alt="SalesCaptain">
                <span class="ml-1 font-semibold text-xs">SalesCaptain</span>
              </div>
            </div>
          </div>
        </div>
        <script>
          window.onload = function() {
            setTimeout(function() { window.print(); }, 300);
          };
        </script>
      </body>
      </html>
    `;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(invoiceHTML);
    iframeDoc.close();

    const cleanup = () => {
      setTimeout(() => {
        if (iframe.parentNode) document.body.removeChild(iframe);
      }, 1500);
    };

    iframe.onload = () => {
      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } catch (e) {
          console.error('Invoice print failed:', e);
        }
        cleanup();
      }, 400);
    };
  };

  if (loading1) {
    return (
      <div className="w-full h-[100vh] items-center justify-between flex flex-col">
        <FiLoader size={50} className="animate-spin mt-[47vh]" />
        <div className='bg-[#fff] flex justify-center items-center relative text-[20px] pb-2 h-[1.5rem] w-full rounded-b-[8px] mb-[5vh]'>
          <span className="text-[#535355]"> Powered by</span>
          <div
            className='flex items-center ml-1 cursor-pointer'
            onClick={() => window.open('https://www.salescaptain.com')}
          >
            <img src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} className=" h-[18px]" alt="" />
            <span
              className="font-semibold ml-1"
            >
              {localStorage.getItem('h_name') ?? 'SalesCaptain'}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-screen h-screen flex-col text-[#1a1a1ab3] bg-gradient-to-br from-blue-50 via-white to-purple-50" >
      {accountId?.length > 0 && (
        <div className=" flex w-screen justify-center">
          <LeftPaymentSide
            product={product}
            companyLogo={companyLogo}
            companyName={companyName}
            paymentType={paymentType}
            setPaymentType={setPaymentType}
            amount={amount}
            handlePay={handlePay}
            loading={loading}
            Surcharge={Surcharge}
            isPaid={isPaid}
            products={products}
            userName={userName}
            handleInvoice={handleInvoice}
            productEnabled={productEnabled}
            taxEnabled={taxEnabled}
            discountEnabled={discountEnabled}
            address={address}
            isExpired={isExpired}
            CompanyId={CompanyId}
            payType={payType}
            paymentIntent={stripeData?.payment_intent}
            paymentMethod={stripeData?.payment_method}
          />
        </div>
      )}
    </div>
  );
};

export default StripePaymentsLink;
